import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var PaginationButtonWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 ", "px;\n"], ["\n  padding: 0 ", "px;\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs;
});
var LeftPaginationButtonWrapper = styled(PaginationButtonWrapper)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0 ", "px;\n  width: ", "px;\n"], ["\n  padding: 0 ", "px;\n  width: ", "px;\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs;
}, function (props) {
  var _a, _b;

  return (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.constants) === null || _b === void 0 ? void 0 : _b.paginationButtonWidth;
});
var Flex = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
export { Flex, LeftPaginationButtonWrapper, PaginationButtonWrapper };